/**
 * Configuración y helpers para @tanstack/react-query
 */

import { QueryClient } from "@tanstack/react-query";

export {
  QueryClientProvider,
  useQuery,
  useQueries,
  useMutation,
  useQueryClient,
  useInfiniteQuery,
  type UseQueryOptions,
  type UseMutationOptions,
  type UseInfiniteQueryOptions,
} from "@tanstack/react-query";

export { QueryClient };

/**
 * Crea un QueryClient con configuración por defecto
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minuto
        gcTime: 5 * 60 * 1000, // 5 minutos (antes cacheTime)
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 1,
      },
    },
  });
}

